import { Pipe, PipeTransform } from '@angular/core';
import { ModelProperty } from '../engine/model-property';
import { ModelPropertyTitleContext } from '../types/model-property-title-context';

@Pipe({
  name: 'modelPropertyTitle',
})
export class ModelPropertyTitlePipe implements PipeTransform {
  public transform(
    property: ModelProperty,
    context?: ModelPropertyTitleContext,
  ): string {
    const titleByContext = this.getTitleByContext(property, context);
    if (titleByContext) {
      return titleByContext;
    }

    if (property.tradKey) {
      return property.tradKey;
    }

    return property.title ?? '';
  }

  private getTitleByContext(
    property: ModelProperty,
    context: ModelPropertyTitleContext | undefined,
  ): string {
    if (!context) {
      return '';
    }
    if (!property.titleByContext) {
      return '';
    }
    return property.titleByContext[context] ?? '';
  }
}
